import { reducer as toastrReducer } from 'react-redux-toastr';
import { combineReducers } from 'redux';
import common from '~/store/ducks/common';
import contactDPO from '~/store/ducks/contactDPO';
import criacaoAssunto from '~/store/ducks/CriacaoDosAssuntosDeContato';
import document from '~/store/ducks/document';
import ExibirHistoricoDeManutencaoDasAtividades from '~/store/ducks/ExibirHistoricoDeManutencaoDasAtividades';
import language from '~/store/ducks/language';
import listaAuditoria from '~/store/ducks/ListaAuditoria';
import ManterAtividadesTratamentoDados from '~/store/ducks/ManterAtividadesTratamentoDados';
import theme from '~/store/ducks/theme';
import user from '~/store/ducks/user';
import VisualizarDadosDosTitulares from '~/store/ducks/VisualizarDadosDosTitulares';
import appControllers from './appControllers';
import auth from './auth';

export default combineReducers({
  toastr: toastrReducer,
  appControllers,
  auth,
  user,
  language,
  contactDPO,
  theme,
  ManterAtividadesTratamentoDados,
  ExibirHistoricoDeManutencaoDasAtividades,
  criacaoAssunto,
  listaAuditoria,
  VisualizarDadosDosTitulares,
  document,
  common,
});
